import { fromCSV } from "dumb-csv";

// if making any changes update `nanoservices/unzip-collection-metadata/src/utils/csv.ts` too
export function convertCsvToJson(csvContent: string) {
  return fromCSV({
    data: csvContent,
    separator: ",",
    parseFloats: false,
  }).toJSON();
}
